// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"885e86fc","72":"2f04f3e8","477":"fa2685c5","627":"3202583b","663":"9ee2c97b","667":"0bcac7ae","777":"c0eddf96","803":"18a2514f","820":"f91ffc49"}[chunkId] + ".chunk.js";
};